import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { SustainabilityFiltersValues } from '@/utils/constants'
import { toArrayQueryParams } from '@/utils/toArrayQueryParams'
import { GetSustainabilityFiltersParams } from '@/hooks'

export const mapSustainabilityFiltersGetParams = (
    filters: SustainabilityFiltersValues
) => {
    const timelineValue = parseTimelineFilter(filters.timeline)

    const params: GetSustainabilityFiltersParams = {
        'nodeIds[]': toArrayQueryParams(filters.node),
        'commodityTypeIds[]': toArrayQueryParams(filters.commodity),
        'contractIds[]': toArrayQueryParams(filters.contract),
        'tagIds[]': toArrayQueryParams(filters.tag),
        'facilityIds[]': toArrayQueryParams(filters.facility),
        'meterIds[]': toArrayQueryParams(filters.meter),
        startDate: timelineValue.startDate,
        endDate: timelineValue.endDate,
    }

    return params
}
